const KEY_COOKIE_POLICY = 'eucookiepolicy=1';
const URL_API = 'https://clfwd.rtbf.be/log';

class Identity{
  constructor(type, typeId) {
    this._type = type;
    this._typeId = typeId;
  }
  toJSON() {
    return {
      type:this._type,
      type_id:this._typeId
    };
  };
}

class Action{

  constructor() {

    this.hasXMLHttpRequest = window.XMLHttpRequest ? true : false;

    /*if (new.target === Action) {
      throw new TypeError("Cannot construct instances directly for : Action");
  }*/
    if (this.type === undefined) {
      throw new TypeError("Must define the property : type");
    }
    if (typeof this.init !== "function") {
      throw new TypeError("Must define the method : init");
    }

    this.init();
  }

  init() {
    throw new TypeError("Must overwrite the method : init");
  }

  // Guess the device form the window width
  getDevice() {
    let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (width < 768) return 'mobile';
    if (width < 992) return 'tablet';
    return 'desktop'
  }

  toJSON() {
    return {
      type: this.type,
      uid: RTBF.sso.uid(),
      sid: RTBF.sso.sid(),
      url: location.href,
      timestamp: new Date().getTime(),
      userAgent: navigator.userAgent,
      device: this.getDevice(),
      identity: this._identity?this._identity.toJSON():undefined,
      details: this._details
    };
  };

  sendAction() {
    try {

      if (!this.hasXMLHttpRequest) return;

      let xhr = new XMLHttpRequest();
      let data = JSON.stringify(this.toJSON());

      xhr.open('POST', URL_API, true);
      xhr.setRequestHeader('Content-type','application/json; charset=utf-8');
      xhr.timeout = 5000;
      xhr.send(data);

    } catch(e) {}

  }
}

export {Action, Identity}
